<!-- 利用状況ダイアログ -->
<template>
  <div>
    <b-modal  class="cx_usage_dialog" v-model="showDialog" :title="title" @ok="onOk" :no-close-on-backdrop="true" centered v-if="showDialog" :ok-only="!hasNextStep" :ok-title="hasNextStep?'次のステップへ':'閉じる'" cancel-title="閉じる" @hidden="$emit('hidden')">
        <!-- ロードマップ -->        
        <div v-if ="showRoadmap"  class="cx_usage_section">
        <span  class="cx_usage_caption">～　{{usageQueryResult.isPreparationCompleted ? 'ロードマップ' : '事前準備'}}&nbsp;&nbsp;{{$api.formatter.formatNumber(usageQueryResult.completedRatio,0) + '% (' + usageQueryResult.completed + '/' + usageQueryResult.total + ')'}}　～</span> 
        <div  class="cx_roadmap_container">
            <div v-if="usageQueryResult.steps.length==0" class="cx_usage_message" >ロードマップは完了しました。</div>
            <div v-for="(item,index) in usageQueryResult.steps" :key="index">
              <div class="cx_roadmap_item" v-if="item.flag == roadmapFlags.Commodity">
                <div class="cx_roadmap_caption"><span class="cx_usage_step">【次のステップ】</span><span>商品の追加</span></div>     
                <div class="cx_roadmap_content" v-if="item.isSourceVoucher"><span class="cx_autolink" @click="onLinkClick(item.url)">商品マスタ一覧</span>に移動し、商品マスタを追加してください。</div>                   
                <div class="cx_roadmap_content" v-if="item.isSourceVoucher == false">商品マスタ(<span class="cx_autolink" @click="onLinkClick(item.url)">{{item.voucherNo}}</span>)に移動し、「確定」を行ってください。</div>                   

              </div>         
              <div class="cx_roadmap_item" v-if="item.flag == roadmapFlags.Customer">
                <div  class="cx_roadmap_caption"> <span class="cx_usage_step">【次のステップ】</span><span>得意先の追加</span></div>     
                <div  class="cx_roadmap_content" v-if="item.isSourceVoucher"><span class="cx_autolink" @click="onLinkClick(item.url)">取引先マスタ一覧</span>に移動し、得意先を追加してください。</div>                   
                <div class="cx_roadmap_content" v-if="item.isSourceVoucher == false">取引先マスタ(<span class="cx_autolink" @click="onLinkClick(item.url)">{{item.voucherNo}}</span>)に移動し、「確定」を行ってください。</div>                                 
              </div>  
              <div class="cx_roadmap_item" v-if="item.flag == roadmapFlags.Supplier">
                <div  class="cx_roadmap_caption"> <span class="cx_usage_step">【次のステップ】</span><span>仕入先の追加</span></div>     
                <div  class="cx_roadmap_content" v-if="item.isSourceVoucher"><span class="cx_autolink" @click="onLinkClick(item.url)">取引先マスタ一覧</span>に移動し、仕入先を追加してください。</div>                   
                <div class="cx_roadmap_content" v-if="item.isSourceVoucher == false">取引先マスタ(<span class="cx_autolink" @click="onLinkClick(item.url)">{{item.voucherNo}}</span>)に移動し、「確定」を行ってください。</div>                                 
              </div>              
              <div class="cx_roadmap_item" v-if="item.flag == roadmapFlags.Warehouse">
                <div  class="cx_roadmap_caption"> <span class="cx_usage_step">【次のステップ】</span><span>倉庫の追加</span></div>     
                <div  class="cx_roadmap_content" v-if="item.isSourceVoucher"><span class="cx_autolink" @click="onLinkClick(item.url)">取引先マスタ一覧</span>に移動し、倉庫を追加してください。</div>                   
                <div class="cx_roadmap_content" v-if="item.isSourceVoucher == false">取引先マスタ(<span class="cx_autolink" @click="onLinkClick(item.url)">{{item.voucherNo}}</span>)に移動し、「確定」を行ってください。</div>                                 
              </div>              
              <div class="cx_roadmap_item" v-if="item.flag == roadmapFlags.Segment">
                <div  class="cx_roadmap_caption"> <span class="cx_usage_step">【次のステップ】</span><span>部門の追加</span></div>     
                <div  class="cx_roadmap_content" v-if="item.isSourceVoucher"><span class="cx_autolink" @click="onLinkClick(item.url)">部門マスタ一覧</span>に移動し、部門を追加してください。</div>                   
                <div class="cx_roadmap_content" v-if="item.isSourceVoucher == false">部門マスタ(<span class="cx_autolink" @click="onLinkClick(item.url)">{{item.voucherNo}}</span>)に移動し、「確定」を行ってください。</div>                                 
              </div>              
              <div class="cx_roadmap_item" v-if="item.flag == roadmapFlags.BankAccount">
                <div  class="cx_roadmap_caption"> <span class="cx_usage_step">【次のステップ】</span><span>銀行口座の追加</span></div>     
                <div  class="cx_roadmap_content" v-if="item.isSourceVoucher"><span class="cx_autolink" @click="onLinkClick(item.url)">銀行口座マスタ一覧</span>に移動し、銀行口座を追加してください。</div>                   
                <div class="cx_roadmap_content" v-if="item.isSourceVoucher == false">銀行口座マスタ(<span class="cx_autolink" @click="onLinkClick(item.url)">{{item.voucherNo}}</span>)に移動し、「確定」を行ってください。</div>                                 
              </div>                                 
              <div class="cx_roadmap_item" v-if="item.flag == (roadmapFlags.SalesOrder|roadmapFlags.PurchaseOrder)">
                <div  class="cx_roadmap_caption"><span class="cx_usage_step">【次のステップ】</span><span>受発注登録</span></div>     
                <div  class="cx_roadmap_content" ><span class="cx_autolink" @click="onLinkClick('/sales/SalesOrder')">受注一覧</span>もしくは<span class="cx_autolink" @click="onLinkClick('/purchase/PurchaseOrder')">発注一覧</span>に移動して新しい伝票を追加してください。</div>                      
              </div>               
              <div class="cx_roadmap_item" v-if="item.flag == roadmapFlags.SalesOrder">
                <div  class="cx_roadmap_caption"><span class="cx_usage_step">【次のステップ】</span><span>受注登録</span></div>     
                <div  class="cx_roadmap_content" v-if="item.isSourceVoucher"><span class="cx_autolink" @click="onLinkClick(item.url)">受注一覧</span>に移動して新しい受注を追加してください。</div>      
                <div class="cx_roadmap_content" v-if="item.isSourceVoucher == false">受注伝票(<span class="cx_autolink" @click="onLinkClick(item.url)">{{item.voucherNo}}</span>)に移動し、「受注確定」を行ってください。</div>                                 
              </div>                   
              <div class="cx_roadmap_item" v-if="item.flag == roadmapFlags.PurchaseOrder">
                <div  class="cx_roadmap_caption"><span class="cx_usage_step">【次のステップ】</span><span>発注登録</span></div>     
                <div  class="cx_roadmap_content"  v-if="item.isSourceVoucher">受注伝票(<span class="cx_autolink" @click="onLinkClick(item.url)">{{item.voucherNo}}</span>)に移動して、「発注処理」を行ってください。</div>          
                <div class="cx_roadmap_content" v-if="item.isSourceVoucher == false">発注伝票(<span class="cx_autolink" @click="onLinkClick(item.url)">{{item.voucherNo}}</span>)に移動し、「発注確定」を行ってください。</div>                                 
              </div>       
              <div class="cx_roadmap_item" v-if="item.flag == roadmapFlags.PurchaseDelivery">
                <div  class="cx_roadmap_caption"><span class="cx_usage_step">【次のステップ】</span><span>入荷処理</span></div>     
                <div  class="cx_roadmap_content"  v-if="item.isSourceVoucher">発注伝票(<span class="cx_autolink" @click="onLinkClick(item.url)">{{item.voucherNo}}</span>)に移動し、「入荷処理」を行ってください。</div>                   
                <div class="cx_roadmap_content" v-if="item.isSourceVoucher == false">入荷伝票(<span class="cx_autolink" @click="onLinkClick(item.url)">{{item.voucherNo}}</span>)に移動し、「入荷確定」を行ってください。</div>                                               
              </div>                
              <div class="cx_roadmap_item" v-if="item.flag == roadmapFlags.PurchasePost">
                <div  class="cx_roadmap_caption"><span class="cx_usage_step">【次のステップ】</span><span>仕入計上</span></div>     
                <div  class="cx_roadmap_content" >仕入伝票(<span class="cx_autolink" @click="onLinkClick(item.url)">{{item.voucherNo}}</span>)に移動し、「仕入計上」を行ってください。</div>                   
              </div>                         
              <div class="cx_roadmap_item" v-if="item.flag == roadmapFlags.PurchasePayment">
                <div  class="cx_roadmap_caption"><span class="cx_usage_step">【次のステップ】</span><span>支払処理</span></div>     
                <div  class="cx_roadmap_content"  v-if="item.isSourceVoucher">仕入伝票(<span class="cx_autolink" @click="onLinkClick(item.url)">{{item.voucherNo}}</span>)に移動し、「支払処理」を行ってください。</div>                   
                <div class="cx_roadmap_content" v-if="item.isSourceVoucher == false">支払伝票(<span class="cx_autolink" @click="onLinkClick(item.url)">{{item.voucherNo}}</span>)に移動し、「支払確定」を行ってください。</div>                                               
              
              </div>                    
              <div class="cx_roadmap_item" v-if="item.flag == roadmapFlags.SalesDelivery">
                <div  class="cx_roadmap_caption"><span class="cx_usage_step">【次のステップ】</span><span>出荷処理</span></div>     
                <div  class="cx_roadmap_content" v-if="item.isSourceVoucher">受注伝票(<span class="cx_autolink" @click="onLinkClick(item.url)">{{item.voucherNo}}</span>)に移動し、「出荷処理」を行ってください。</div>                   
                <div class="cx_roadmap_content" v-if="item.isSourceVoucher == false">出荷伝票(<span class="cx_autolink" @click="onLinkClick(item.url)">{{item.voucherNo}}</span>)に移動し、「出荷確定」を行ってください。</div>                                               
                            
              </div>                
              <div class="cx_roadmap_item" v-if="item.flag == roadmapFlags.SalesPost">
                <div  class="cx_roadmap_caption"> <span class="cx_usage_step">【次のステップ】</span><span>請求処理</span></div>     
                <div  class="cx_roadmap_content"  v-if="item.isSourceVoucher">出荷伝票(<span class="cx_autolink" @click="onLinkClick(item.url)">{{item.voucherNo}}</span>)に移動し、「請求処理」を行ってください。</div>                   
                <div class="cx_roadmap_content" v-if="item.isSourceVoucher == false">請求書(<span class="cx_autolink" @click="onLinkClick(item.url)">{{item.voucherNo}}</span>)に移動し、「請求締処理」を行ってください。</div>                                               
                            
              </div>                         
              <div class="cx_roadmap_item" v-if="item.flag == roadmapFlags.SalesPayment">
                <div  class="cx_roadmap_caption"> <span class="cx_usage_step">【次のステップ】</span><span>入金処理</span></div>     
                <div  class="cx_roadmap_content"  v-if="item.isSourceVoucher">請求書(<span class="cx_autolink" @click="onLinkClick(item.url)">{{item.voucherNo}}</span>)に移動し、「入金処理」を行ってください。</div>                   
                <div class="cx_roadmap_content" v-if="item.isSourceVoucher == false">入金伝票(<span class="cx_autolink" @click="onLinkClick(item.url)">{{item.voucherNo}}</span>)に移動し、「入金確定」を行ってください。</div>                                               
                                  
              </div>                                                       
            </div>
        </div>
        </div>
        <!-- 利用状況 -->
        <div class="cx_usage_section">      
          <span  class="cx_usage_caption">～　現在の利用状況　～</span>              
          <div class="cx_switch" v-if="$api.license.isTrial == false"><toggle-button v-model="currentMonth" :labels="{checked: '当月表示', unchecked: '前月表示'}" :width="80" :font-size="12" color="#007bff"/></div>
          <div class="cx_usage_container">
            <div class="cx_usage_panel">
              <span class="cx_usage_title">【マスタ登録状況】</span>
              <div class="cx_usage_item" v-for="(item,index) in usageCountersMaster" :key="index">
                <span > {{item.name}}</span>     
                <span > {{item.count == 0 ? '未実施': item.count + '件'}}<i  v-if="item.count !=0" class="material-icons small valign cx_ok">check_circle</i><i  v-if="item.count ==0" class="material-icons small valign cx_alert">warning</i></span>                   
              </div>                 
            </div>            
            <div class="cx_usage_panel">
              <span  class="cx_usage_title">【販売登録状況】</span>
              <div class="cx_usage_item" v-for="(item,index) in usageCountersSales" :key="index">
                <span > {{item.name}}</span>     
                <span > {{item.count == 0 ? '未実施': item.count + '件'}}<i  v-if="item.count !=0" class="material-icons small valign cx_ok">check_circle</i><i  v-if="item.count ==0" class="material-icons small valign cx_alert">warning</i></span>                   
              </div>       
            </div>
            <div class="cx_usage_panel">
              <span  class="cx_usage_title">【仕入登録状況】</span>            
              <div class="cx_usage_item" v-for="(item,index) in usageCountersPurchase" :key="index">
                <span > {{item.name}}</span>     
                <span > {{item.count == 0 ? '未実施': item.count + '件'}}<i  v-if="item.count !=0" class="material-icons small valign cx_ok">check_circle</i><i  v-if="item.count ==0" class="material-icons small valign cx_alert">warning</i></span>                   
              </div>                   
            </div>          
            
          </div>        

        　<span  class="cx_usage_description">※確定件数をカウントしています。</span>          
        </div>       
    </b-modal>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit,Watch } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';

@Component
export default class UsageDialog extends Vue {
  @Prop({default:false}) public showRoadmap:boolean; 
  @Prop({default:null}) public roadmapMessage:string;
  currentMonth:boolean = true;
  showDialog: boolean = false;
  usageQueryResult : Common.UsageQueryResult;
  roadmapFlags = Common.RoadmapFlags;

  get title():string{
    if (this.showRoadmap) return this.usageQueryResult.isPreparationCompleted? "ロードマップ" : "事前準備";
    else return "利用状況照会"
  }
  usageCountersMaster :Common.UsageCounter[] = [];
  usageCountersSales :Common.UsageCounter[] = [];
  usageCountersPurchase :Common.UsageCounter[] = [];
  
  get hasNextStep():boolean {
    if (this.showRoadmap && this.usageQueryResult.steps  && this.usageQueryResult.steps.length > 0) return true;
    else return false;
  }
  onOk(){
    this.showDialog = false;
    if (this.hasNextStep){
      var step = this.usageQueryResult.steps[0];
      this.onLinkClick(step.url);
    }
  }
  created(){

    var countType = Common.UsageCountType.Default;
    if (this.$api.license.isTrial == false) countType = this.currentMonth ? Common.UsageCountType.CurrentMonth : Common.UsageCountType.PreviousMonth;

    this.$api.execute(new Common.UsageQuery(countType))
    .then(obj => {
        this.usageQueryResult = obj;
        this.setCounters();
        if(this.$api.license.isTrial) this.$api.setRoadmapRatio(this.usageQueryResult);
        if(this.showRoadmap) this.$api.clearRoadmapAlert();
        this.showDialog = true;
      })
  }
  onLinkClick(path : string){
     this.showDialog = false;
    this.$router.push(path);
  }

  setCounters(){
    this.usageCountersMaster = this.usageQueryResult.counters.filter(obj =>obj.roadmapFlag == Common.RoadmapFlags.Default || obj.roadmapFlag >= Common.RoadmapFlags.Commodity);
    this.usageCountersSales = this.usageQueryResult.counters.filter(obj =>obj.roadmapFlag >= Common.RoadmapFlags.SalesOrder && obj.roadmapFlag <= Common.RoadmapFlags.SalesPayment);
    this.usageCountersPurchase= this.usageQueryResult.counters.filter(obj =>obj.roadmapFlag >= Common.RoadmapFlags.PurchaseOrder && obj.roadmapFlag <= Common.RoadmapFlags.PurchasePayment);
  }
  @Watch('currentMonth')
  public reload(){
    this.$api.execute(new Common.UsageQuery(this.currentMonth ? Common.UsageCountType.CurrentMonth : Common.UsageCountType.PreviousMonth))
    .then(obj => {
        this.usageQueryResult = obj;
        this.setCounters();
        if(this.$api.license.isTrial) this.$api.setRoadmapRatio(this.usageQueryResult);
        this.$forceUpdate();
      })
  }
}
</script>
<style lang="scss">
@import '@/agiles/components/style.scss';
.cx_usage_dialog{
  @include cx_dialog_spmode;
  .modal-dialog{
    width: 750px !important;
    max-width: 750px !important;
    white-space: break-spaces !important;

    .modal-body {
      font-size: 14px;
      span{
        text-align: center;      
        display: inline-block;
        margin-bottom: unset;
      }
    }
  .vue-js-switch .v-switch-label{
    top:15px !important;
  }
  .cx_switch{
    display:flex;
    justify-content: flex-end;
  }
  .cx_usage_section    {
    margin : 20px 50px;    
  }
  .cx_usage_step {
    margin-right :10px;
 
  }
   .cx_usage_caption{
        // display: inline-block;     
        margin:10px 20px;
        font-size: 18px;     
        // text-decoration: underline;
        font-weight: 700;
   }
   .cx_usage_message{
        margin :20px;     
   }   
   .cx_usage_description{
        // display: inline-block;   
        margin :20px;
        font-size: 12px;      
   }
  .cx_usage_container{
    display: flex;
    justify-content:space-between;

    .cx_usage_panel{
      width:180px;

      .cx_usage_title{
        // display: inline-block;           
        margin :10px;
        font-size: 16px;
        // font-weight: 700;
      }
      .cx_usage_item {
        display: flex;
        justify-content: space-between;

        .material-icons{
          &.cx_ok{
            color: #4ec23f;
          }
          &.cx_alert{
            color: #c516166c;            
          }
          font-size: 14px;
          margin-left:5px;
        }
      }
    }
  }

  .cx_roadmap_container{

    .cx_roadmap_item{
      margin : 15px 0px;
      display: flex;
      text-align: left;
      flex-direction: column;
      align-items: center;
      // white-space: nowrap;
      .cx_roadmap_caption{
          // width:220px;
          font-weight: 700;             
      }
      .cx_roadmap_content{
        margin-top:5px;
          // width:480px;
      }      
    }
  }

  }

}
</style>